import { defineMessages } from 'react-intl';

export const syncQueueStatusMessages = defineMessages({
  conflict: {
    id: 'app.inventory.sync.status.conflict',
  },
  needs_review: {
    id: 'app.inventory.sync.status.needs_review',
  },
  queued: {
    id: 'app.inventory.sync.status.queued',
  },
  sync_failed: {
    id: 'app.inventory.sync.status.sync_failed',
  },
  syncing: {
    id: 'app.inventory.sync.status.syncing',
  },
  synced: {
    id: 'app.inventory.sync.status.synced',
  },
});

export const workflowTypeMessages = defineMessages({
  inventorize: {
    id: 'app.inventory.sync.workflow.inventorize',
  },
  meter_replacement: {
    id: 'app.inventory.sync.workflow.meter_replacement',
  },
  sensor_installation: {
    id: 'app.inventory.sync.workflow.sensor_installation',
  },
  service_inspection: {
    id: 'app.inventory.sync.workflow.service_inspection',
  },
});

export const messages = defineMessages({
  metersNoPlacementDetails: {
    id: 'app.inventory.meters.noPlacementDetails',
  },
  syncDrafts: {
    id: 'app.inventory.sync.drafts',
  },
  syncEmptyQueueDescription: {
    id: 'app.inventory.sync.emptyQueueDescription',
  },
  syncErrorLoadSyncCenter: {
    id: 'app.inventory.sync.errorLoadSyncCenter',
  },
  syncErrorRunSync: {
    id: 'app.inventory.sync.errorRunSync',
  },
  syncOffline: {
    id: 'app.inventory.sync.offline',
  },
  syncFailed: {
    id: 'app.inventory.sync.failed',
  },
  syncNeedsReview: {
    id: 'app.inventory.sync.needsReview',
  },
  syncPending: {
    id: 'app.inventory.sync.pending',
  },
  syncPhotos: {
    id: 'app.inventory.sync.photos',
  },
  syncQueueRecords: {
    id: 'app.inventory.sync.queueRecords',
  },
  syncProgressCurrent: {
    id: 'app.inventory.sync.progress.current',
  },
  syncProgressDescription: {
    id: 'app.inventory.sync.progress.description',
  },
  syncProgressEmpty: {
    id: 'app.inventory.sync.progress.empty',
  },
  syncProgressTitle: {
    id: 'app.inventory.sync.progress.title',
  },
  syncRetry: {
    id: 'app.inventory.sync.retry',
  },
  syncRetryFailedReview: {
    id: 'app.inventory.sync.retryFailedReview',
  },
  syncSynced: {
    id: 'app.inventory.sync.synced',
  },
  syncSyncNow: {
    id: 'app.inventory.sync.syncNow',
  },
});
